// Pipeline snippets for the Testify CLI (Settings → API tokens). Keep in sync with cli/README.md.

export const CI_PROVIDERS = [
	{ id: "github", label: "GitHub Actions", secretHint: "Repository → Settings → Secrets and variables → Actions → New secret TESTIFY_TOKEN" },
	{ id: "gitlab", label: "GitLab CI", secretHint: "Project → Settings → CI/CD → Variables → add TESTIFY_TOKEN (Masked)" },
	{ id: "jenkins", label: "Jenkins", secretHint: "Manage Jenkins → Credentials → add a Secret text with the ID testify-token" },
	{ id: "azure", label: "Azure DevOps", secretHint: "Pipeline → Edit → Variables → add TESTIFY_TOKEN (Keep this value secret)" },
];

const q = (s) => s.replace(/"/g, '\\"');

export function ciSnippet(provider, origin, suite = "Smoke") {
	const run = `node testify.mjs run --suite "${q(suite)}" --junit testify-report.xml`;
	switch (provider) {
		case "github":
			return `# .github/workflows/testify.yml
name: Testify
on: [push]
jobs:
  testify:
    runs-on: ubuntu-latest
    steps:
      - name: Run Testify suite
        env:
          TESTIFY_URL: ${origin}
          TESTIFY_TOKEN: \${{ secrets.TESTIFY_TOKEN }}
        run: |
          curl -fsSLO "$TESTIFY_URL/downloads/testify.mjs"
          ${run}
      - name: Upload report
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: testify-report
          path: testify-report.xml`;
		case "gitlab":
			return `# .gitlab-ci.yml
testify:
  image: node:20
  variables:
    TESTIFY_URL: ${origin}
  script:
    - curl -fsSLO "$TESTIFY_URL/downloads/testify.mjs"
    - ${run}
  artifacts:
    when: always
    reports:
      junit: testify-report.xml`;
		case "jenkins":
			return `// Jenkinsfile
pipeline {
  agent any
  environment {
    TESTIFY_URL = '${origin}'
    TESTIFY_TOKEN = credentials('testify-token')
  }
  stages {
    stage('Testify') {
      steps {
        sh 'curl -fsSLO "$TESTIFY_URL/downloads/testify.mjs"'
        sh '${run.replace(/'/g, "\\'")}'
      }
    }
  }
  post {
    always {
      junit allowEmptyResults: true, testResults: 'testify-report.xml'
    }
  }
}`;
		case "azure":
			return `# azure-pipelines.yml
steps:
  - script: |
      curl -fsSLO "$TESTIFY_URL/downloads/testify.mjs"
      ${run}
    displayName: Run Testify suite
    env:
      TESTIFY_URL: ${origin}
      TESTIFY_TOKEN: $(TESTIFY_TOKEN)
  - task: PublishTestResults@2
    condition: always()
    inputs:
      testResultsFormat: JUnit
      testResultsFiles: testify-report.xml`;
		default:
			return "";
	}
}
